import m from "mithril";
import i18n from "../i18n/i18n";
import ModalManagerV2 from '../modal_v2';
import Modal_ConfirmV2 from '../components/modal_confirmV2';
import {EnrolmentStatus} from "./courseEnrolmentStatus_utilities";

export function changeEnrolmentStatusPrompt(confirmCallback, status, isPassed, effectiveDate) {
    const statusKey = status ?? EnrolmentStatus.NOT_STARTED;
    const statusText = i18n.t(statusKey);
    const consequenceKey = `change_status_to_${statusKey}_consequence`;
    const consequenceText = i18n.t(consequenceKey);
    const renderNote = () => m("b", i18n.t("change_status_note"));
    const statusChangeOrResetMessageKey = status === EnrolmentStatus.PASSED ? 'change_status_confirm' : 'reset_status_confirm';
    const messageText = [
        i18n.t(statusChangeOrResetMessageKey, {status: statusText.toUpperCase()}),
        m("br"), m("br"),
        consequenceText,
        m("br"), m("br")
    ];

    if (isPassed && (status === EnrolmentStatus.NOT_STARTED || status === EnrolmentStatus.FAILED)) {
        console.log(renderNote());
        messageText.push(renderNote());
    }

    const attributes = {
        confirmCallback: () => confirmCallback(status, effectiveDate),
        cancelCallback: null,
        messageText: messageText,
        confirmButtonLabel: i18n.t('yes'),
        cancelButtonLabel: i18n.t('no'),
        confirmButtonClasses: 'button.btn-yes',
        cancelButtonClasses: 'button.btn-no'
    };
    ModalManagerV2.open(i18n.t('change_status_confirmation'), ['modal-mid'], Modal_ConfirmV2, attributes);
}

